// extracted by mini-css-extract-plugin
module.exports = {"base":"AdaptiveCard-module-base","backgroundLayer":"AdaptiveCard-module-background-layer","surfaceLayer":"AdaptiveCard-module-surface-layer"};